import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

interface ArticleCardProps {
  article: Article;
}

export default function ArticleCard({ article }: ArticleCardProps) {
  return (
    <article className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer">
      <Link to={`/article/${article.id}`} className="block">
        <div className="aspect-[16/9] overflow-hidden">
          <img
            src={article.coverImage}
            alt={article.title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            loading="lazy"
          />
        </div>
        <div className="p-4 md:p-5">
          <div className="flex items-center gap-2 mb-2">
            <span className="px-2 py-0.5 bg-primary-100 text-primary-700 text-xs font-medium rounded-md whitespace-nowrap">
              {article.categoryName}
            </span>
            <span className="text-xs text-foreground-500">{article.readTime} 分钟阅读</span>
          </div>
          <h3 className="font-heading text-base md:text-lg text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 mb-2">
            {article.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2 mb-3 leading-relaxed">
            {article.excerpt}
          </p>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <div className="w-6 h-6 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                <img
                  src={article.author.avatar}
                  alt={article.author.name}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <span className="text-xs text-foreground-600">{article.author.name}</span>
            </div>
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {article.views >= 1000 ? `${(article.views / 1000).toFixed(1)}k` : article.views}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-heart-line"></i>
                {article.likes}
              </span>
            </div>
          </div>
        </div>
      </Link>
    </article>
  );
}